(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552,9495],{

/***/ 77086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ googleLogout; },
/* harmony export */   "kZ": function() { return /* binding */ GoogleLogin; },
/* harmony export */   "rg": function() { return /* binding */ GoogleOAuthProvider; }
/* harmony export */ });
/* unused harmony exports hasGrantedAllScopesGoogle, hasGrantedAnyScopeGoogle, useGoogleLogin, useGoogleOAuth, useGoogleOneTapLogin */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client'
;

function useLoadGsiScript(options = {}) {
    const { nonce, onScriptLoadSuccess, onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onScriptLoadSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = () => {
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = () => {
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [nonce]);
    return scriptLoadedSuccessfully;
}

const GoogleOAuthContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function GoogleOAuthProvider({ clientId, nonce, onScriptLoadSuccess, onScriptLoadError, children, }) {
    const scriptLoadedSuccessfully = useLoadGsiScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [clientId, scriptLoadedSuccessfully]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(GoogleOAuthContext.Provider, { value: contextValue }, children));
}
function useGoogleOAuth() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GoogleOAuthContext);
    if (!context) {
        throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    }
    return context;
}

function extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}

const containerHeightMap = { large: 40, medium: 32, small: 20 };
function GoogleLogin({ onSuccess, onError, useOneTap, promptMomentNotification, type = 'standard', theme = 'outline', size = 'large', text, shape, logo_alignment, width, locale, click_listener, containerProps, ...props }) {
    const btnContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            ...props,
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.renderButton(btnContainerRef.current, {
            type,
            theme,
            size,
            text,
            shape,
            logo_alignment,
            width,
            locale,
            click_listener,
        });
        if (useOneTap)
            (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            if (useOneTap)
                (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale,
    ]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ...containerProps, ref: btnContainerRef, style: { height: containerHeightMap[size], ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style } }));
}

function googleLogout() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.disableAutoSelect();
}

/* eslint-disable import/export */
function useGoogleLogin({ flow = 'implicit', scope = '', onSuccess, onError, onNonOAuthError, overrideScope, state, ...props }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const clientRef = useRef();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = useRef(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    useEffect(() => {
        var _a, _b;
        if (!scriptLoadedSuccessfully)
            return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response) => {
                var _a, _b;
                if (response.error)
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 ? void 0 : _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError) => {
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state,
            ...props,
        });
        clientRef.current = client;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, scriptLoadedSuccessfully, flow, scope, state]);
    const loginImplicitFlow = useCallback((overrideConfig) => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig); }, []);
    const loginAuthCodeFlow = useCallback(() => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode(); }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}

function useGoogleOneTapLogin({ onSuccess, onError, promptMomentNotification, cancel_on_tap_outside, prompt_parent_id, state_cookie_domain, hosted_domain, use_fedcm_for_prompt = false, use_fedcm_for_button = false, disabled, auto_select, }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = useRef(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            hosted_domain,
            cancel_on_tap_outside,
            prompt_parent_id,
            state_cookie_domain,
            use_fedcm_for_prompt,
            use_fedcm_for_button,
            auto_select,
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        use_fedcm_for_prompt,
        use_fedcm_for_button,
        disabled,
        auto_select,
    ]);
}

/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */
function hasGrantedAllScopesGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false);
}

/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */
function hasGrantedAnyScopeGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false);
}




/***/ }),

/***/ 3954:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(26784);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 26784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ about_us; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/PageWrapper/index.ts + 1 modules
var PageWrapper = __webpack_require__(96424);
// EXTERNAL MODULE: ./components/SEO/index.ts + 1 modules
var SEO = __webpack_require__(38743);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/image.js
var next_image = __webpack_require__(26538);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/AboutUs/WhoWeAre.module.scss
var WhoWeAre_module = __webpack_require__(18967);
var WhoWeAre_module_default = /*#__PURE__*/__webpack_require__.n(WhoWeAre_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-awesome-reveal@4.3.1_@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_sup_9ec67bc2838b979fc11a3db5ae856235/node_modules/react-awesome-reveal/dist/index.js + 2 modules
var dist = __webpack_require__(56399);
;// CONCATENATED MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.14.0_@types+react@18.0.21_react@18.2.0_supports-color@7.2.0/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(87098);
;// CONCATENATED MODULE: ./components/Animation/Animation.tsx

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    transform: rotateY(90deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: rotateY(0deg); \n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    transform: rotateY(90deg);\n  }\n\n  to {\n    opacity: 1;\n    transform: rotateT(0deg);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var flipFromRight = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject());
var flipFromLeft = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject1());

// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
;// CONCATENATED MODULE: ./components/AboutUs/WhoWeAre.tsx







var WhoWeAre = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WhoWeAre_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhoWeAre_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhoWeAre_module_default()).leftSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* default */.ZP, {
                        keyframes: flipFromLeft,
                        duration: 1000,
                        delay: 100,
                        triggerOnce: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-md",
                                color: "grayDark-300",
                                weight: "medium",
                                className: (WhoWeAre_module_default()).label,
                                children: "Who We Are"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "display-md",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (WhoWeAre_module_default()).heading,
                                children: "A team building production"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                color: "grayDark-600",
                                className: (WhoWeAre_module_default()).description,
                                children: "EPEN is a technology-driven company focused on building professional tools and frameworks for video development and high-performance software systems. We help developers, studios, and production teams design, build, and scale advanced video solutions with precision, performance, and reliability."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                color: "grayDark-600",
                                className: (WhoWeAre_module_default()).description,
                                children: "We believe that powerful tools should simplify complexity — not add to it."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhoWeAre_module_default()).rightSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                        keyframes: flipFromRight,
                        duration: 1000,
                        delay: 200,
                        triggerOnce: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WhoWeAre_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/about/who-we-are.jpg",
                                alt: "Who We Are",
                                layout: "fill",
                                objectFit: "cover"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutUs_WhoWeAre = (WhoWeAre);

// EXTERNAL MODULE: ./components/AboutUs/MissionVision.module.scss
var MissionVision_module = __webpack_require__(886);
var MissionVision_module_default = /*#__PURE__*/__webpack_require__.n(MissionVision_module);
;// CONCATENATED MODULE: ./components/AboutUs/MissionVision.tsx






var MissionVision = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (MissionVision_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MissionVision_module_default()).content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MissionVision_module_default()).cardsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MissionVision_module_default()).missionCard,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                            keyframes: flipFromLeft,
                            duration: 1000,
                            delay: 100,
                            triggerOnce: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MissionVision_module_default()).cardContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "display-xl",
                                        as: "h2",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        className: (MissionVision_module_default()).title,
                                        children: "Our Mission"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-lg",
                                        color: "grayDark-50",
                                        className: (MissionVision_module_default()).description,
                                        children: "Our mission is to create robust, developer-friendly technologies that streamline the development of video plugins, graphics tools, and performance-critical software. We aim to reduce technical friction and enable teams to focus on creativity, innovation, and product quality."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MissionVision_module_default()).visionCard,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                            keyframes: flipFromLeft,
                            duration: 1000,
                            delay: 200,
                            triggerOnce: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MissionVision_module_default()).cardContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "display-xl",
                                        as: "h2",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        className: (MissionVision_module_default()).title,
                                        children: "Our Vision"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-lg",
                                        color: "grayDark-50",
                                        className: (MissionVision_module_default()).description,
                                        children: "We envision EPEN as a global reference point for advanced video and software development solutions. By combining deep engineering expertise with a strong understanding of real-world production needs, we strive to shape the future of video technology across platforms and industries."
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var AboutUs_MissionVision = (MissionVision);

// EXTERNAL MODULE: ./components/AboutUs/WhatWeDo.module.scss
var WhatWeDo_module = __webpack_require__(17052);
var WhatWeDo_module_default = /*#__PURE__*/__webpack_require__.n(WhatWeDo_module);
;// CONCATENATED MODULE: ./components/AboutUs/WhatWeDo.tsx







var WhatWeDo = function() {
    var productCapabilities = [
        "Video plugin frameworks for professional editing platforms",
        "High-performance graphics and video processing tools",
        "Cross-platform software systems with optimized performance",
        "GPGPU and hardware-accelerated solutions",
        "Product configuration and technical guidance for complex production pipelines", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WhatWeDo_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhatWeDo_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhatWeDo_module_default()).leftSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                        keyframes: flipFromLeft,
                        duration: 1000,
                        delay: 100,
                        triggerOnce: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (WhatWeDo_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/about/what-we-do.jpg",
                                alt: "What We Do",
                                width: 1024,
                                height: 1024,
                                layout: "responsive"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhatWeDo_module_default()).rightSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* default */.ZP, {
                        keyframes: flipFromRight,
                        duration: 1000,
                        delay: 200,
                        triggerOnce: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (WhatWeDo_module_default()).iconWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (WhatWeDo_module_default()).icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M9 17.5H3.5M6.5 12H2M9 6.5H4M17 3L10.4036 12.235C10.1116 12.6438 9.96562 12.8481 9.97194 13.0185C9.97744 13.1669 10.0486 13.3051 10.1661 13.3958C10.3011 13.5 10.5522 13.5 11.0546 13.5H16L15 21L21.5964 11.765C21.8884 11.3562 22.0344 11.1519 22.0281 10.9815C22.0226 10.8331 21.9514 10.6949 21.8339 10.6042C21.6989 10.5 21.4478 10.5 20.9454 10.5H16L17 3Z",
                                            stroke: "#E9D7FE",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "display-sm",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (WhatWeDo_module_default()).heading,
                                children: "What We Do"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                color: "grayDark-600",
                                className: (WhatWeDo_module_default()).intro,
                                children: "At EPEN, we design and develop product-focused solutions, including:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (WhatWeDo_module_default()).servicesList,
                                children: productCapabilities.map(function(capability, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: (WhatWeDo_module_default()).serviceItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (WhatWeDo_module_default()).checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 12 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M10 3L4.5 8.5L2 6",
                                                        stroke: "#ffffff",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                variant: "text-lg",
                                                color: "grayDark-600",
                                                className: (WhatWeDo_module_default()).serviceText,
                                                children: capability
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutUs_WhatWeDo = (WhatWeDo);

// EXTERNAL MODULE: ./components/AboutUs/WhyEpen.module.scss
var WhyEpen_module = __webpack_require__(95073);
var WhyEpen_module_default = /*#__PURE__*/__webpack_require__.n(WhyEpen_module);
;// CONCATENATED MODULE: ./components/AboutUs/WhyEpen.tsx






var WhyEpen = function() {
    var pillars = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "23",
                height: "22",
                viewBox: "0 0 23 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.09436 10.2288C5.03221 9.82823 4.99996 9.41786 4.99996 9C4.99996 4.58172 8.60525 1 13.0526 1C17.4999 1 21.1052 4.58172 21.1052 9C21.1052 9.99807 20.9213 10.9535 20.5852 11.8345C20.5154 12.0175 20.4804 12.109 20.4646 12.1804C20.4489 12.2512 20.4428 12.301 20.4411 12.3735C20.4394 12.4466 20.4493 12.5272 20.4692 12.6883L20.8717 15.9585C20.9153 16.3125 20.9371 16.4895 20.8782 16.6182C20.8266 16.731 20.735 16.8205 20.6211 16.8695C20.4911 16.9254 20.3146 16.8995 19.9617 16.8478L16.7765 16.3809C16.6101 16.3565 16.527 16.3443 16.4512 16.3448C16.3763 16.3452 16.3245 16.3507 16.2511 16.3661C16.177 16.3817 16.0823 16.4172 15.893 16.4881C15.0097 16.819 14.0524 17 13.0526 17C12.6344 17 12.2237 16.9683 11.8227 16.9073M6.63158 21C9.59648 21 12 18.5376 12 15.5C12 12.4624 9.59648 10 6.63158 10C3.66668 10 1.26316 12.4624 1.26316 15.5C1.26316 16.1106 1.36028 16.6979 1.53955 17.2467C1.61533 17.4787 1.65322 17.5947 1.66566 17.6739C1.67864 17.7567 1.68091 17.8031 1.67608 17.8867C1.67145 17.9668 1.65141 18.0573 1.61134 18.2383L1 21L3.9948 20.591C4.15827 20.5687 4.24 20.5575 4.31137 20.558C4.38652 20.5585 4.42641 20.5626 4.50011 20.5773C4.5701 20.5912 4.67416 20.6279 4.88227 20.7014C5.43059 20.8949 6.01911 21 6.63158 21Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Performance-Driven",
            description: "Engineering excellence with a strong focus on performance and scalability"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M13 2L3 14H12L11 22L21 10H12L13 2Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Production-Ready",
            description: "Deep domain knowledge in video processing and software architecture"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "21",
                height: "21",
                viewBox: "0 0 21 21",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9 2H5.8C4.11984 2 3.27976 2 2.63803 2.32698C2.07354 2.6146 1.6146 3.07354 1.32698 3.63803C1 4.27976 1 5.11984 1 6.8V15.2C1 16.8802 1 17.7202 1.32698 18.362C1.6146 18.9265 2.07354 19.3854 2.63803 19.673C3.27976 20 4.11984 20 5.8 20H14.2C15.8802 20 16.7202 20 17.362 19.673C17.9265 19.3854 18.3854 18.9265 18.673 18.362C19 17.7202 19 16.8802 19 15.2V12M10 7H14V11M13.5 2.5V1M17.4393 3.56066L18.5 2.5M18.5103 7.5H20.0103M1 12.3471C1.65194 12.4478 2.31987 12.5 3 12.5C7.38636 12.5 11.2653 10.3276 13.6197 7",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Deep Technical Focus",
            description: "Reliable, maintainable solutions designed for long-term use"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                width: "21",
                height: "19",
                viewBox: "0 0 21 19",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.60802 12C7.60802 12 8.92052 13.5 11.108 13.5C13.2955 13.5 14.608 12 14.608 12M13.858 7H13.868M8.35802 7H8.36802M11.108 18C15.8024 18 19.608 14.1944 19.608 9.5C19.608 4.80558 15.8024 1 11.108 1C6.4136 1 2.60802 4.80558 2.60802 9.5C2.60802 10.45 2.76387 11.3636 3.05139 12.2166C3.15959 12.5376 3.21369 12.6981 3.22345 12.8214C3.23309 12.9432 3.2258 13.0286 3.19568 13.1469C3.16517 13.2668 3.09782 13.3915 2.96312 13.6408L1.32746 16.6684C1.09415 17.1002 0.977493 17.3161 1.0036 17.4828C1.02634 17.6279 1.11177 17.7557 1.2372 17.8322C1.3812 17.9201 1.62532 17.8948 2.11356 17.8444L7.23459 17.315C7.38967 17.299 7.46721 17.291 7.53788 17.2937C7.6074 17.2963 7.65647 17.3029 7.72426 17.3185C7.79318 17.3344 7.87984 17.3678 8.05318 17.4345C9.00123 17.7998 10.0312 18 11.108 18ZM14.358 7C14.358 7.27614 14.1342 7.5 13.858 7.5C13.5819 7.5 13.358 7.27614 13.358 7C13.358 6.72386 13.5819 6.5 13.858 6.5C14.1342 6.5 14.358 6.72386 14.358 7ZM8.85802 7C8.85802 7.27614 8.63417 7.5 8.35802 7.5C8.08188 7.5 7.85802 7.27614 7.85802 7C7.85802 6.72386 8.08188 6.5 8.35802 6.5C8.63417 6.5 8.85802 6.72386 8.85802 7Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Reliable by Design",
            description: "Close technical collaboration to ensure solutions align with real production needs"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WhyEpen_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (WhyEpen_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (WhyEpen_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                            variant: "text-md",
                            color: "grayDark-300",
                            weight: "medium",
                            className: (WhyEpen_module_default()).label,
                            children: "Why EPEN"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                            variant: "display-md",
                            as: "h2",
                            color: "grayDark-50",
                            weight: "semibold",
                            className: (WhyEpen_module_default()).heading,
                            children: "Built for teams that demand performance, reliability, and clarity"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (WhyEpen_module_default()).pillarsGrid,
                    children: pillars.map(function(pillar, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                            keyframes: flipFromLeft,
                            duration: 1000,
                            delay: 100 * index,
                            triggerOnce: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (WhyEpen_module_default()).pillarCard,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (WhyEpen_module_default()).iconWrapper,
                                        children: pillar.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-lg",
                                        as: "h3",
                                        color: "grayDark-50",
                                        weight: "semibold",
                                        className: (WhyEpen_module_default()).pillarTitle,
                                        children: pillar.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-md",
                                        color: "grayDark-600",
                                        className: (WhyEpen_module_default()).pillarDescription,
                                        children: pillar.description
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutUs_WhyEpen = (WhyEpen);

// EXTERNAL MODULE: ./components/AboutUs/OurValues.module.scss
var OurValues_module = __webpack_require__(3401);
var OurValues_module_default = /*#__PURE__*/__webpack_require__.n(OurValues_module);
;// CONCATENATED MODULE: ./components/AboutUs/OurValues.tsx







var OurValues = function() {
    var values = [
        "Precision over shortcuts",
        "Clarity over complexity",
        "Reliability over hype",
        "Long-term impact over quick wins", 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (OurValues_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (OurValues_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (OurValues_module_default()).leftSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* default */.ZP, {
                        keyframes: flipFromLeft,
                        duration: 1000,
                        delay: 100,
                        triggerOnce: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "display-lg",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (OurValues_module_default()).heading,
                                children: "Our Values"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (OurValues_module_default()).valuesList,
                                children: values.map(function(value, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: (OurValues_module_default()).valueItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (OurValues_module_default()).checkIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                    width: "28",
                                                    height: "28",
                                                    viewBox: "0 0 28 28",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                            clipPath: "url(#clip0_1856_33713)",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                d: "M8.7526 14L12.2526 17.5L19.2526 10.5M25.6693 14C25.6693 20.4434 20.4459 25.6667 14.0026 25.6667C7.55928 25.6667 2.33594 20.4434 2.33594 14C2.33594 7.55672 7.55928 2.33337 14.0026 2.33337C20.4459 2.33337 25.6693 7.55672 25.6693 14Z",
                                                                stroke: "#9E77ED",
                                                                strokeWidth: "2.33333",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                                                                id: "clip0_1856_33713",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
                                                                    fill: "white"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                variant: "text-lg",
                                                color: "grayDark-600",
                                                className: (OurValues_module_default()).valueText,
                                                children: value
                                            })
                                        ]
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                color: "grayDark-600",
                                className: (OurValues_module_default()).conclusion,
                                children: "These values guide every product we build and every partnership we form."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (OurValues_module_default()).rightSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
                        keyframes: flipFromRight,
                        duration: 1000,
                        delay: 200,
                        triggerOnce: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (OurValues_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/about/our-values.jpg",
                                alt: "Our Values",
                                width: 1024,
                                height: 1024,
                                layout: "responsive"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var AboutUs_OurValues = (OurValues);

// EXTERNAL MODULE: ./components/AboutUs/WorkWithUs.module.scss
var WorkWithUs_module = __webpack_require__(66545);
var WorkWithUs_module_default = /*#__PURE__*/__webpack_require__.n(WorkWithUs_module);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(32033);
;// CONCATENATED MODULE: ./components/AboutUs/WorkWithUs.tsx







var WorkWithUs = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (WorkWithUs_module_default()).workWithUsSection,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (WorkWithUs_module_default()).workWithUsContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (WorkWithUs_module_default()).workWithUsCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist/* default */.ZP, {
                        keyframes: flipFromLeft,
                        duration: 1000,
                        delay: 100,
                        triggerOnce: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "display-md",
                                as: "h2",
                                color: "grayDark-50",
                                weight: "semibold",
                                className: (WorkWithUs_module_default()).workWithUsTitle,
                                children: "Work With Us"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xl",
                                color: "grayDark-600",
                                className: (WorkWithUs_module_default()).workWithUsDescription,
                                children: "Whether you are developing a new video product, optimizing an existing pipeline, or exploring custom technical solutions, EPEN is ready to help."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        label: "Get in touch to start a conversation",
                        onClick: function() {
                            window.location.href = "/contact-us";
                        },
                        variant: "primary"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var AboutUs_WorkWithUs = (WorkWithUs);

;// CONCATENATED MODULE: ./pages/about-us.tsx










var AboutUsPage = function(param) {
    var aboutData = param.aboutData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "About Us",
                description: "Learn about EPEN Ltd., a technology-driven company focused on building professional tools and frameworks for video development and high-performance software systems.",
                type: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageWrapper/* default */.Z, {
                dateText: "About us",
                titleText: "About the company",
                introText: "Learn more about the company and the team behind it.",
                title: "About Us",
                aboutData: aboutData,
                contentContainerClass: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_WhoWeAre, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_MissionVision, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_WhatWeDo, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_WhyEpen, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_OurValues, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs_WorkWithUs, {})
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var about_us = (AboutUsPage);


/***/ }),

/***/ 886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MissionVision_container__FIPPc","content":"MissionVision_content__TkxGY","cardsWrapper":"MissionVision_cardsWrapper__qewH1","missionCard":"MissionVision_missionCard__zPgzj","visionCard":"MissionVision_visionCard__11PeX","cardContent":"MissionVision_cardContent__AL4qN","title":"MissionVision_title__vLN0s"};

/***/ }),

/***/ 3401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OurValues_container__DqNuM","content":"OurValues_content__AHc1L","leftSection":"OurValues_leftSection__xcJsD","heading":"OurValues_heading__kuHgC","valuesList":"OurValues_valuesList__Dppmw","valueItem":"OurValues_valueItem__YfLYJ","checkIcon":"OurValues_checkIcon__bUUx3","valueText":"OurValues_valueText__5oSzw","conclusion":"OurValues_conclusion__E6c4Z","rightSection":"OurValues_rightSection__ycrDM","imageWrapper":"OurValues_imageWrapper___Zfrz"};

/***/ }),

/***/ 17052:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WhatWeDo_container__He4ds","content":"WhatWeDo_content__Bu0hJ","leftSection":"WhatWeDo_leftSection__N5LWz","imageWrapper":"WhatWeDo_imageWrapper__3_bzV","rightSection":"WhatWeDo_rightSection___J7RG","iconWrapper":"WhatWeDo_iconWrapper__Eo9WQ","icon":"WhatWeDo_icon__8L0Pl","heading":"WhatWeDo_heading__nsowf","intro":"WhatWeDo_intro__vKWKp","servicesList":"WhatWeDo_servicesList__qMG_J","serviceItem":"WhatWeDo_serviceItem__MwUFV","checkIcon":"WhatWeDo_checkIcon__IxdML","serviceText":"WhatWeDo_serviceText__bzdRy"};

/***/ }),

/***/ 18967:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WhoWeAre_container__1Bhkf","content":"WhoWeAre_content__GAK9I","leftSection":"WhoWeAre_leftSection__xIt2O","label":"WhoWeAre_label__vi5GC","heading":"WhoWeAre_heading__gPscU","description":"WhoWeAre_description__EOyGn","rightSection":"WhoWeAre_rightSection__swPRC","imageWrapper":"WhoWeAre_imageWrapper__lnwyW"};

/***/ }),

/***/ 95073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"WhyEpen_container__N6Ydz","content":"WhyEpen_content__vteBZ","header":"WhyEpen_header__yuu9g","label":"WhyEpen_label__IiD9n","heading":"WhyEpen_heading__AwjwT","pillarsGrid":"WhyEpen_pillarsGrid__Y_FJu","pillarCard":"WhyEpen_pillarCard__W11_c","iconWrapper":"WhyEpen_iconWrapper__d4Vbb","pillarTitle":"WhyEpen_pillarTitle__5Pjxn"};

/***/ }),

/***/ 66545:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"workWithUsSection":"WorkWithUs_workWithUsSection__44USR","workWithUsContainer":"WorkWithUs_workWithUsContainer__cU7oU","workWithUsCard":"WorkWithUs_workWithUsCard__AmFrX","workWithUsTitle":"WorkWithUs_workWithUsTitle__q7vrY","workWithUsDescription":"WorkWithUs_workWithUsDescription__oZoHV"};

/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 97508:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 31922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; },
/* harmony export */   "y": function() { return /* binding */ SkeletonTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    if (typeof customHighlightBackground === 'string')
        style['--custom-highlight-background'] = customHighlightBackground;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3977,6538,6607,8030,6399,2033,5304,6309,9774,2888,179], function() { return __webpack_exec__(3954); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);